@if (!smallScreen) {
<div class="fleet-fields-wrapper">
  <label><i class="pi pi-search magnify-icon accent-color"></i></label>
  <ng-container *ngTemplateOutlet="filters"></ng-container>
</div>
} @if (smallScreen) {
<div class="mobile-search-buttons">
  <button pButton severity="info" class="clear-button" (click)="showFilterDialog()">
    <i class="clear-icon" [innerHTML]="iconService.getIcon('filter')"></i>
    <span pButtonLabel>{{ 'global.filter' | translate }}</span>
  </button>
</div>
<p-dialog
  header="{{ 'global.filter' | translate }}"
  position="top"
  [modal]="true"
  [(visible)]="filterDialogVisible"
  [appendTo]="'body'"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  styleClass="filter-dialog-mobile"
>
  <div class="fields-panel filter-dialog-mobile-content">
    <ng-container *ngTemplateOutlet="filters"></ng-container>
  </div>
</p-dialog>
}
<ng-template #filters data-cy="mobile-filter-panel">
  @if (search) {
  <div class="search-wrapper">
    <div class="filter" [ngClass]="{ 'filter-active': searchFilter?.length > 0 }">
      <p-floatLabel variant="in">
        <p-select
          #searchSelect
          inputId="search_filter"
          [(ngModel)]="searchFilter"
          [disabled]="disable"
          (ngModelChange)="onSearchChange($event)"
          (onFocus)="onSearchFocus()"
          [options]="searchHistory"
          [editable]="true"
          dropdownIcon="dropdown-search"
          data-cy="search-filter"
        >
        </p-select>
        <label for="search_filter">{{ 'global.search' | translate }}</label>
      </p-floatLabel>
    </div>
  </div>
  } @if (state) {
  <div class="filter" [ngClass]="{ 'filter-active': stateFilter?.length > 0 }">
    <p-floatLabel variant="in">
      <p-multiSelect
        inputId="state_filter"
        [ngModel]="stateFilter"
        [options]="stateOptions"
        optionLabel="name"
        dataKey="name"
        (onChange)="stateFilterChange.emit($event.value)"
        (onClear)="stateFilter = []; stateFilterChange.emit([])"
        [showToggleAll]="stateOptions?.length > 10"
        [filter]="stateOptions?.length > 10"
        [maxSelectedLabels]="1"
        [showClear]="true"
      >
      </p-multiSelect>
      <label for="state_filter">{{ 'fleet.table.stage' | translate }}</label>
    </p-floatLabel>
  </div>
  } @if (alarm) {
  <div class="filter" [ngClass]="{ 'filter-active': alarmFilter?.length > 0 }">
    <p-floatLabel variant="in">
      <p-multiSelect
        inputId="alarm_filter"
        [ngModel]="alarmFilter"
        [options]="alarmOptions"
        optionLabel="name"
        optionValue="value"
        (onChange)="alarmFilterChange.emit($event.value)"
        (onClear)="alarmFilter = []; alarmFilterChange.emit([])"
        [showToggleAll]="alarmOptions?.length > 10"
        [filter]="alarmOptions?.length > 10"
        [maxSelectedLabels]="1"
        [showClear]="true"
      >
      </p-multiSelect>
      <label for="alarm_filter">{{ 'fleet.table.alertEvents' | translate }}</label>
    </p-floatLabel>
  </div>
  } @if (comms) {
  <div class="filter" [ngClass]="{ 'filter-active': commsFilter?.length > 0 }">
    <p-floatLabel variant="in">
      <p-multiSelect
        inputId="comms_filter"
        [ngModel]="commsFilter"
        [options]="commsOptions"
        optionLabel="name"
        optionValue="value"
        (onChange)="commsFilterChange.emit($event.value)"
        (onClear)="commsFilter = []; commsFilterChange.emit([])"
        [showToggleAll]="commsOptions?.length > 10"
        [filter]="commsOptions?.length > 10"
        [maxSelectedLabels]="1"
        [showClear]="true"
      >
      </p-multiSelect>
      <label for="comms_filter">{{ 'fleet.table.comms.onOffline' | translate }}</label>
    </p-floatLabel>
  </div>
  } @if (status) {
  <div class="filter" [ngClass]="{ 'filter-active': statusFilter?.length > 0 }">
    <p-floatLabel variant="in">
      <p-multiSelect
        inputId="status_filter"
        [ngModel]="statusFilter"
        [options]="statusOptions"
        optionLabel="name"
        dataKey="name"
        [appendTo]="'body'"
        (onChange)="statusFilterChange.emit($event.value)"
        (onClear)="statusFilter = []; statusFilterChange.emit([])"
        [showToggleAll]="statusOptions?.length > 10"
        [filter]="statusOptions?.length > 10"
        [maxSelectedLabels]="smallScreen ? 0 : 1"
        [showClear]="true"
        [panelStyleClass]="smallScreen ? 'status-multiselect-panel-small' : ''"
      >
      </p-multiSelect>
      <label for="status_filter">{{ 'fleet.table.status' | translate }}</label>
    </p-floatLabel>
  </div>
  }@if (clearButton) {
  <p-button
    data-cy="clear-filters"
    class="clear-button"
    severity="secondary"
    [text]="true"
    (click)="clearFilters.emit(true)"
  >
    <ng-template pTemplate="icon">
      <span class="accent-color clear-icon" [innerHTML]="iconService.getIcon('filter-remove')"></span>
    </ng-template>
  </p-button>
  }
</ng-template>
